import { useAppStateMachine } from '@/components/providers/app-state-machine-provider';

export const useAppState = () => {
    const { state } = useAppStateMachine();

    return {
        superAdmin: state.context.superAdmin,
        platoUser: state.context.platoUser,
        tenantId: state.context.tenantId,
        primaryUserType: state.context.primaryUserType,
        appIsLoading: state.context.appIsLoading,
        userIsLoading: state.context.userIsLoading,
        superAdminImpersonatingPlatoUserId: state.context.superAdminImpersonatingPlatoUserId,
        salesRepIds: state.context.platoUser?.salesRepIds ?? [],
        salesRepId:
            state.context.platoUser && state.context.platoUser.showDataForErpSalesRepId
                ? state.context.platoUser.erpSalesRepId
                    ? state.context.platoUser.erpSalesRepId
                    : undefined
                : undefined,
    };
};
